import { SET_AUDIO_TIME, SET_MOVE_TIME, TOGGLE_PLAY, RESET_STATE, SET_VOLUME } from "./audioActions";

const initialState = {
  currentAudioTime: 0,
  moveToTime: 0,
  isPlaying: false,
  volume: 100
};

const audioReducer = (state = initialState, action ) => {
  switch (action.type) {
    case SET_AUDIO_TIME:
      return {
        ...state,
        currentAudioTime: action.payload
      };
    case SET_MOVE_TIME:
      return {
        ...state,
        moveToTime: action.payload
      };
    case TOGGLE_PLAY:
      return {
        ...state,
        isPlaying: action.payload === undefined ? !state.isPlaying : action.payload
      };
    case SET_VOLUME:
      return {
        ...state,
        volume: action.payload
      };
    case RESET_STATE:
      return { ...initialState, volume: state.volume };

    default:
      return { ...state };
  }
};

export default audioReducer;
